import type { FieldPath, FieldValues } from "react-hook-form";
import type { ValidFormField } from "src/components/Form/Form.types.ts";

export const getFieldConfig = <
  FormValues extends FieldValues = FieldValues,
  TName extends FieldPath<FormValues> = FieldPath<FormValues>,
>(
  fields: Record<string, ValidFormField<any>>,
  name: TName,
): ValidFormField | undefined => {
  return fields[name] as ValidFormField | undefined;
};
